'use strict';

/*globals K2Application*/

function K2ApplicationSpecial(services) {
  K2Application.call(this, services);

  this.initSpecial();
}

K2ApplicationSpecial.prototype = $.extend({}, K2Application.prototype, {
  constructor: 'K2ApplicationSpecial',

  //**************************************************************************

  showMessage: function showMessage(data, callback) {
    var _this = this;

    _this.services.get('output-service').showMessage(data, callback);

    return _this;
  },

  showMessageHtml: function showMessageHtml(data, callback) {
    var _this = this;

    _this.services.get('output-service').showMessageHtml(data, callback);

    return _this;
  },

  confirmHtml: function confirmHtml(data, callback) {
    var _this = this;

    _this.services.get('confirm-service').confirmHtml(data, callback);

    return _this;
  },

  confirmCancelHtml: function confirmCancelHtml(data, callback) {
    var _this = this;

    _this.services.get('confirm-service').confirmCancelHtml(data, callback);

    return _this;
  },

  getValue: function getValue(data, callback) {
    var _this = this;

    _this.services.get('input-service').getValue(data, callback);

    return _this;
  },

  getValueWithRes: function getValueWithRes(data, callback) {
    var _this = this;

    _this.services.get('input-service').getValueWithRes(data, callback);

    return _this;
  },

  selectValue: function selectValue(data, callback) {
    var _this = this;

    _this.services.get('select-service').selectValue(data, callback);

    return _this;
  },

  getAltUnit: function getAltUnit(unit) {
    var _this = this;

    var altUnit = null;
    $.each(_this.param('units'), function (key, value) {
      if (value.Unit === unit) {
        altUnit = value;
        return false;
      }
    });

    return altUnit;
  },

  paramById: function paramById(param, id) {
    var _this = this;

    var value = null;
    var arr = _this.param(param);

    $.each(arr, function (key, item) {
      if (item.id === id) {
        value = item;
        return false;
      }
    });

    return value;
  },

  //**************************************************************************

  initSpecial: function initSpecial() {
    var _this = this;

    return _this;
  }
});
